import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { memberRepairMoney } from '../../../../api/apis';
export default {
  data: function data() {
    var _this = this;

    return {
      dialogVisible: false,
      tagList: [{
        key: 0,
        value: '补款'
      }, {
        key: 1,
        value: '扣款'
      }],
      form: {
        number: '',
        type: 'money1',
        tag: 0,
        happen_money: '',
        remark: ''
      },
      rules: {
        happen_money: [{
          required: true,
          message: '请输入积分',
          trigger: 'change'
        }, {
          required: true,
          validator: _this.$tempModel.rules.integer.validator,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(number, finish) {
      this.dialogVisible = true;
      this.form.number = number;
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        console.log('dsadadsa', valid);

        if (valid) {
          memberRepairMoney(_this2.form).then(function _callee(res) {
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.$message({
                      message: '操作成功',
                      type: 'success'
                    });

                    _this2.dialogVisible = false;

                    if (_this2.finish) {
                      _this2.finish();
                    }

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};